export const ROLE_OPTIONS = [
  {
    label: "User.ReadWrite - Read and modify user data",
    shortLabel: "User.ReadWrite",
    value: "User.ReadWrite",
  },
  {
    label: "User.Read - View user data",
    shortLabel: "User.Read",
    value: "User.Read",
  },
  {
    label: "Stats.Read - View system statistics",
    shortLabel: "Stats.Read",
    value: "Stats.Read",
  },
  {
    label: "Outbound.Read - Read outbound statistics",
    shortLabel: "Outbound.Read",
    value: "Outbound.Read",
  },
  {
    label: "Inbound.Read - Read inbound statistics",
    shortLabel: "Inbound.Read",
    value: "Inbound.Read",
  },
  {
    label: "CDR.Read - View Call Detail Records",
    shortLabel: "CDR.Read",
    value: "CDR.Read",
  },
  {
    label: "CallRecordings.Read - Read call recordings",
    shortLabel: "CallRecordings.Read",
    value: "CallRecordings.Read",
  },
  {
    label: "CallRecordings.ReadWrite - Read and write call recordings",
    shortLabel: "CallRecordings.ReadWrite",
    value: "CallRecordings.ReadWrite",
  },
  {
    label: "Realtime.read - Monitor real-time activity",
    shortLabel: "Realtime.read",
    value: "Realtime.read",
  },
];